import { Component, OnInit } from '@angular/core';
import { sessionStorageKey } from 'src/app/doctors-station/doctors-station.constants';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';

@Component({
  selector: 'app-doctors-next-login',
  templateUrl: './doctors-next-login.component.html',
  styleUrls: ['./doctors-next-login.component.css', '../style/index.css'],
})
export class DoctorsNextLoginComponent
  extends BaseLoginComponent
  implements OnInit
{
  flagment?: string;
  async ngOnInit() {
    this.activateRoute.fragment.subscribe((fragment) => {
      this.flagment = fragment;
      if (!this.flagment) {
        this.email = '';
        this.password = '';
      }
    });
  }
  async init(): Promise<void> {}

  async _login() {
    const isValid = await this.isValidEmailAndPassword();
    if (!isValid) return;

    const flags = await this.auth.getFlags({
      clientId: this.clientId,
      email: this.email,
      redirectUri: this.redirectUri,
    });

    // フラグが立っている場合は通常通り
    if (flags.doctors_products) {
      return this.login();
    }

    // cp_productsがtrueの場合は連携ページへ遷移させる
    if (flags.cp_products) {
      // sessionStorageにメールアドレスを保存
      sessionStorage.setItem(
        sessionStorageKey.doctorsNextCpIntegration.email,
        this.email
      );
      await this.router.navigate([], {
        queryParamsHandling: 'preserve',
        fragment: 'doctors-next-cp-integration',
      });
      this.flagment = 'doctors-next-cp-integration';
      return;
    }

    // ここまで来た場合はどちらのフラグが立っていない場合 = 存在しないユーザ
    // 既存処理に入れるため通常のログイン処理を行う
    return this.login();
  }
}
